
export const GOOGLE_PLAY_LINK = 'market://details?id=br.gov.dataprev.meucadunico';
export const APPLE_STORE_LINK = 'itms-apps://itunes.apple.com/app/id1605659516';
